<template>
  <main class="pt-0">
    <!-- Header / Home -->
    <section id="home" style="margin-top: 0px !important" class="text-white">
      <div :class="['bg-home', { 'bg-loaded': isBackgroundLoaded }]">
        <div class="text-center">
          <img class="img-fluid mb-5" src="/images/logos/HomeLogo.png" alt="..." />
          <h1 class="questrial-regular fs-3">BUILDING THE FUTURE OF MEDICINE WITH AGENTIC AI</h1>
        </div>
      </div>
      <div class="separador"></div>
    </section>
    <!-- Other Sections -->
    <Carousel class="background-opacity" :totalSlides="4" :texts="texts" :textsMobile="textsMobile" :titles="titles" :thumbnails="thumbnails" :imagesURL="imagesURL" :slideTime="10" />
    <Products />
    <Commitments />
    <Contact />
  </main>
</template>

<script>
import { GlobalMixin } from '@mixins/GlobalMixin';
import modalConfirmacion from '@snippets/base/Confirmation.vue';
import modalAlerta from '@snippets/base/Alerta.vue';
import Carousel from '@snippets/base/Carousel.vue';
import Contact from '@components/landing/Contact.vue';
import Products from '@components/landing/Products.vue';
import Commitments from '@components/landing/Commitments.vue';

export default {
  components: { modalConfirmacion, modalAlerta, Carousel, Contact, Products, Commitments },
  mixins: [GlobalMixin],
  name: 'Home',
  data() {
    return {
      isBackgroundLoaded: false,
      titles: ['Comprehensive Offerings', 'Innovative Tech & Tools', 'Partnership & Vision', 'Our Commitment'],
      thumbnails: ['Comprehensive Offerings', 'Innovative Tech & Tools', 'Partnership & Vision', 'Our Commitment'],
      imagesURL: ['/images/Brillos.png', '/images/Brillos.png', '/images/Brillos.png', '/images/Brillos.png'],
      texts: [
        `AI Alpha Analytics specializes in developing
              <span class="text-gold oswald-font">AI-driven solutions</span>
              to help medical organizations excel in a digital world by solving complex challenges, enhancing efficiency, and driving growth.`,
        `We offer a range of <span class="text-gold oswald-font">advanced tools</span>, including predictive analytics, automation, and data insights, designed to meet diverse medical needs with <span class="text-gold oswald-font">reliable and scalable software.</span> `,
        `Committed to building strong, trust-based partnerships, AI Alpha Analytics focuses on
              <span class="text-gold oswald-font">delivering impactful solutions</span>
              that meet current demands and anticipate future opportunities in medical technology.`,
        `Our mission is to push medical technology's boundaries by delivering intelligent, adaptable, and tailored solutions. Focused on addressing current challenges, we also equip organizations to lead in an ever-evolving digital landscape. <br /><br />
              <span class="text-gold oswald-font">With AI Alpha Analytics, you're not just keeping up with the medical future, you're leading it.</span>`,
      ],
      textsMobile: [
        `AI Alpha Analytics specializes in developing
              <span class="text-gold oswald-font">AI-driven solutions</span>
              to help medical organizations excel in a digital world by solving complex challenges, enhancing efficiency, and driving growth.`,
        `We offer a range of <span class="text-gold oswald-font">advanced tools</span>, including predictive analytics, automation, and data insights, designed to meet diverse medical needs with <span class="text-gold oswald-font">reliable and scalable software.</span> `,
        `Committed to building strong, trust-based partnerships, AI Alpha Analytics focuses on
              <span class="text-gold oswald-font">delivering impactful solutions</span>
              that meet current demands and anticipate future opportunities in medical technology.`,
        `Our mission is to push medical technology's boundaries by delivering intelligent, adaptable, and tailored solutions. Focused on addressing current challenges, we also equip organizations to lead in an ever-evolving digital landscape. <br /><br />
              <span class="text-gold oswald-font">With AI Alpha Analytics, you're not just keeping up with the medical future, you're leading it.</span>`,
      ],
    };
  },
  methods: {
    loadBackgroundImage() {
      const img = new Image();
      img.src = '/videos/Home.gif';
      img.onload = () => {
        this.isBackgroundLoaded = true;
      };
    },
  },
  mounted() {
    this.loadBackgroundImage();
  },
};
</script>
